import { useCoachingGroupsQuery } from "../../../networking/coachingGroups/queries"

export const useGetProfileById = (profileId: number) => {
  const { data: coachingGroups } = useCoachingGroupsQuery()
  const clientProfile = coachingGroups
    ?.flatMap((group) => group.profiles)
    .find((profile) => profile.id === profileId)
  return clientProfile
}
